import './AvatarImageCard.css';
import { useState, ChangeEvent } from 'react';
import { IUserBase } from '../../types/type';
import img from '../../assets/profile.png';
import { store } from '../../store/store';
import { RotatableImage } from '../RotatableImage/RotatableImage';
import { instance } from '../../api/api';
import { isAbsoluteUrl, mediaUrl } from '../../utils/utils';

export interface ImageCardProps {
  user: IUserBase;
}

function AvatarImageCard({ user }: ImageCardProps) {
  const baseURL = store.getState().config.baseURL;
  const [avatar, setAvatar] = useState<string>(mediaUrl(user.avatar, baseURL) ?? img);

  const updateUser = async (file: File) => {
    const formData = new FormData();
    formData.append('avatar', file);

    try {
      const response = await instance.post<{ avatar?: string }>(`/profiles/avatar/${user.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response && response.data) {
        setAvatar(mediaUrl(response.data.avatar, baseURL) ?? img);
      }
    } catch (error) {
      console.error('Ошибка при загрузке аватара:', error);
    }
  };

  const handleAvatarChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target?.result) {
          setAvatar(e.target.result as string);
          updateUser(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // After a rotate is saved, reload the image. A cache-buster is only safe on a
  // relative (locally served) path; a presigned S3 URL is signed as-is and any
  // extra query param would invalidate it, so it is reused unchanged.
  const handleRotateSuccess = () => {
    if (!user.avatar) return;
    if (isAbsoluteUrl(user.avatar)) {
      setAvatar(user.avatar);
      return;
    }
    setAvatar(`${mediaUrl(user.avatar, baseURL)}?t=${new Date().getTime()}`);
  };

  return (
    <div className="image__card">
      <div className="status">
        <span className={`dot ${user?.isActive ? 'active' : ''}`}></span>
        {user?.isActive ? 'Активен' : 'Неактивен'}
      </div>

      <div className="avatar-uploader">
        <label htmlFor="avatar-input">
          <RotatableImage
            imageUrl={avatar}
            alt="Аватар"
            photoType="avatar"
            entityId={user.id.toString()}
            endpoint="/profiles"
            className="avatar-container"
            style={{ width: '100%', height: '100%' }}
            showControls={true}
            onRotateSuccess={handleRotateSuccess}
          />
        </label>
        <input
          id="avatar-input"
          type="file"
          accept="image/*"
          onChange={handleAvatarChange}
          style={{ display: 'none' }}
        />
      </div>

      <div className="role">
        {user.role == 'driver'
          ? 'Водитель'
          : user.role == 'technik'
            ? 'Техник'
            : user.role == 'medic'
              ? 'Медик'
              : user.role == 'autopark_employee'
                ? 'Представитель автопарка'
                : 'Админ'}
      </div>
    </div>
  );
}

export default AvatarImageCard;
